// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14K-Z","name":"Header_name__1yqC8","birthday":"Header_birthday__2e0MO","skeleton":"Header_skeleton__2tOZW"};